import React from 'react';
import {Card, Grid, Typography} from 'antd';
import {MailOutlined} from '@ant-design/icons';
import {useTheme} from '../components/ThemeProvider';

const {Title, Paragraph, Link} = Typography;
const {useBreakpoint} = Grid;

const ContactPage: React.FC = () => {
    const screens = useBreakpoint();
    const {isDark} = useTheme();

    return (
        <div style={{
            padding: screens.md ? '24px' : '16px',
            maxWidth: '800px',
            margin: '0 auto',
        }}>
            <Card
                style={{ borderRadius: '12px' }}
                styles={{ body: { padding: screens.md ? '32px' : '20px' } }}
            >
                <Title level={2}>Contact</Title>

                <Paragraph style={{fontSize: '16px', lineHeight: '1.8'}}>
                    We'd love to hear from you. Whether you have feedback, questions, partnership inquiries,
                    or just want to say hello — reach out to us.
                </Paragraph>

                <div style={{
                    padding: '24px',
                    borderRadius: '12px',
                    background: isDark ? '#1f1f1f' : '#f5f5f5',
                    marginTop: '24px',
                    marginBottom: '24px',
                }}>
                    <Title level={4} style={{marginTop: 0}}>
                        <MailOutlined style={{marginRight: '8px'}}/>
                        Email
                    </Title>
                    <Paragraph style={{fontSize: '16px', margin: 0}}>
                        <Link href="mailto:contact@metagame.news">contact@metagame.news</Link>
                    </Paragraph>
                </div>

                <Paragraph type="secondary" style={{fontSize: '14px'}}>
                    We typically respond within 1–2 business days.
                </Paragraph>
            </Card>
        </div>
    );
};

export default ContactPage;
